module.exports = __webpack_public_path__ + "img/1528799278.fef1e0ac.jpg";